var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconAdminPermissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "admin-permissions__State=Admin-permissions, Type=Enabled",
    className: "admin-permissions__State=Admin-permissions, admin-permissions__Type=Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "admin-permissions__Vector 211 (Stroke)",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.125 4.311a.25.25 0 0 0-.416-.001l-3.75 5.58a1.25 1.25 0 0 1-1.81.285L2.413 7.232a.25.25 0 0 0-.402.234l1.28 8.282h17.393l1.357-8.343a.25.25 0 0 0-.397-.24L17.61 10.2a1.25 1.25 0 0 1-1.794-.31l-3.691-5.579Zm8.986 12.936H2.819c-.367.203-.716.607-.828 1.051-.059.23-.052.463.04.693.091.231.288.509.69.792.003.002.028.017.084.017h18.323c.324-.224.655-.705.712-1.216a1.209 1.209 0 0 0-.127-.712c-.102-.196-.284-.414-.602-.625ZM1.828 16.1l-1.3-8.404C.287 6.126 2.094 5.07 3.342 6.054L6.865 8.83l3.599-5.357a1.75 1.75 0 0 1 2.912.01l3.544 5.358 3.822-2.875c1.26-.947 3.032.123 2.78 1.68l-1.382 8.493c.398.3.699.65.902 1.037a2.71 2.71 0 0 1 .289 1.576c-.111.984-.715 1.868-1.406 2.319-.285.185-.59.23-.824.23H2.805a1.64 1.64 0 0 1-.95-.293c-.593-.419-1-.915-1.219-1.464a2.602 2.602 0 0 1-.1-1.613c.192-.76.694-1.415 1.292-1.83Z",
    className: "admin-permissions__Vector admin-permissions__211 admin-permissions__(Stroke)",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconAdminPermissions);
export default __webpack_public_path__ + "static/media/sidebar-icon-admin-permissions.274545919e5ac94ec0db2bd7732d4609.svg";
export { ForwardRef as ReactComponent };